import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';

export default function Navbar() {
  const { t } = useTranslation();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/80'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-7xl mx-auto">
          <Link to="/" className="flex items-center gap-2 group">
            <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-bold text-lg">
              <i className="ri-plug-line"></i>
            </span>
            <span className="text-lg font-bold text-foreground-950 font-heading">
              {t('siteName')}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                isActive('/')
                  ? 'bg-primary-50 text-primary-600'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              {t('nav.home')}
            </Link>
            <Link
              to="/category/caozuo-fangfa"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                location.pathname.startsWith('/category')
                  ? 'bg-primary-50 text-primary-600'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              {t('nav.categories')}
            </Link>
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                isActive('/about')
                  ? 'bg-primary-50 text-primary-600'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              {t('nav.about')}
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-600 hover:bg-background-100 transition-colors"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden border-t border-background-200 bg-background-50">
            <div className="px-4 py-3 space-y-1">
              <Link
                to="/"
                className={`block px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 ${
                  isActive('/') ? 'bg-primary-50 text-primary-600' : 'text-foreground-600 hover:bg-background-100'
                }`}
              >
                {t('nav.home')}
              </Link>
              <Link
                to="/category/caozuo-fangfa"
                className={`block px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 ${
                  location.pathname.startsWith('/category') ? 'bg-primary-50 text-primary-600' : 'text-foreground-600 hover:bg-background-100'
                }`}
              >
                {t('nav.categories')}
              </Link>
              <Link
                to="/about"
                className={`block px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 ${
                  isActive('/about') ? 'bg-primary-50 text-primary-600' : 'text-foreground-600 hover:bg-background-100'
                }`}
              >
                {t('nav.about')}
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}